import { render, staticRenderFns } from "./selfback.vue?vue&type=template&id=e9e0da76&scoped=true&"
import script from "./selfback.vue?vue&type=script&lang=js&"
export * from "./selfback.vue?vue&type=script&lang=js&"
import style0 from "./selfback.vue?vue&type=style&index=0&id=e9e0da76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e0da76",
  null
  
)

export default component.exports